// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602251055/js/" + chunkId + "." + {"44":"451122e9","225":"fe9e6adc","481":"4179b4ba","486":"43678abf","770":"c83335e7"}[chunkId] + ".0.20140754332406252.chunk.js";
};